<template name="dialog-tip">
	<div class="tip-dialog">
		<!-- 确认关闭活动 -->
		<el-dialog
		  title="商品分组效果预览"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false"
		>
		<img src="../../assets/img/pro-group/tip.png"/>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			close() {
				this.$emit('close');
			}
		},
		mounted() {
			
		}
	}
</script>

<style scoped>
	.tip-dialog .el-dialog__body {
		padding-top: 0;
		padding-bottom: 16px;
	}
	.tip-dialog .el-dialog {
		width: 373px;
	}
	.tip-dialog img{
		width: 278px;
		height: 329px;
		margin: 20px auto 0 auto;
		display: block;
	}
</style>
